import { AlarmLevel } from '../../models/enum';
import { Group } from '../../models/entities';
import { getMarkerIcon } from './getMarkerIcon';

export const getGroupMarker = (group: Group, index: number, alarmLevel?: AlarmLevel) => {
    let message = `<span>${group.uniqueName}</span>`;
    message = `${message}<br/><span>${group.shortComment}</span>`;
    return {
        autoPanOnFocus: false,
        draggable: false,
        guid: group.guid,
        icon: getMarkerIcon(alarmLevel),
        lat: parseFloat(group.customProperties['latitude']),
        lng: parseFloat(group.customProperties['longitude']),
        message,
        objectType: 'Group',
        popupOptions: {
            closeButton: false
        },
        riseOnHover: false,
        zIndexOffset: getzIndexOffset(index, alarmLevel)
    };
};

const getzIndexOffset = (index: number, alarmLevel?: AlarmLevel) => {
    let offset = 0;
    switch (alarmLevel) {
        case 2:
            offset = index + 30000;
            break;
        case 1:
            offset = index + 20000;
            break;
        case 0:
            offset = index + 10000;
            break;
    }
    return offset;
};
